import * as actionTypes from '../actionTypes';

const state = {
  userRoles: [],
  isLoggedIn: false,
  isLoadingCheckLogin: false,
  checkLoginMessage: '',
  checkLoginFailed: '',

  isLoadingRegister: false,
  registerMessage: '',
  registerFailed: '',

  isLoadingCheckRepeatAccount: false,
  checkRepeatAccountMessage: {},
  checkRepeatAccountFailed: '',

  isLoadingEmailAuthenticated: false,
  isEmailAuthenticatedMessage: {},
  isEmailAuthenticatedFailed: '',

  isLoadingReSendRegisterAuthenticated: false,
  reSendRegisterAuthenticatedMessage: {},
  reSendRegisterAuthenticatedFailed: '',

  isLoadingSendForgotPasswordEmail: false,
  sendForgotPasswordEmailMessage: {},
  sendForgotPasswordEmailFailed: '',

  isLoadingResetNewPassword: false,
  resetNewPasswordMessage: {},
  resetNewPasswordFailed: '',

  isLoadingCheckTokenExpired: false,
  checkTokenExpiredMessage: '',
  checkTokenExpiredFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function authReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
        userRoles: globalState.userRoles,
      };
    // 設定 roles
    case actionTypes.SET_USER_ROLES:
      return {
        ...globalState,
        userRoles: action.roles,
      };
    case actionTypes.SET_IS_LOGGED_IN:
      return {
        ...globalState,
        isLoggedIn: action.isLoggedIn,
      };
    case actionTypes.SET_IS_LOGIN:
      return {
        ...globalState,
      };
    case actionTypes.SET_USER_AUTHENTICATED:
      return {
        ...globalState,
      };
    case actionTypes.LOGOUT:
      return {
        ...globalState,
      };
    // 登入
    case actionTypes.CHECK_LOGIN_PENDING:
      return {
        ...globalState,
        isLoadingCheckLogin: true,
      };
    case actionTypes.CHECK_LOGIN_FULFILLED:
      return {
        ...globalState,
        isLoadingCheckLogin: false,
        checkLoginMessage: action.data,
        checkLoginFailed: '',
      };
    case actionTypes.CHECK_LOGIN_FAILURE:
      return {
        ...globalState,
        isLoadingCheckLogin: false,
        checkLoginMessage: '',
        checkLoginFailed: action.error,
      };
    // 信箱驗證
    case actionTypes.POST_REGISTER_AUTHENTICATED_PENDING:
      return {
        ...globalState,
        isLoadingEmailAuthenticated: true,
      };
    case actionTypes.POST_REGISTER_AUTHENTICATED_FULFILLED:
      return {
        ...globalState,
        isLoadingEmailAuthenticated: false,
        isEmailAuthenticatedMessage: action.data,
      };
    case actionTypes.POST_REGISTER_AUTHENTICATED_FAILURE:
      return {
        ...globalState,
        isLoadingEmailAuthenticated: false,
        isEmailAuthenticatedFailed: action.error,
      };
    // 重發驗證信
    case actionTypes.RESEND_REGISTER_AUTHENTICATED_PENDING:
      return {
        ...globalState,
        isLoadingReSendRegisterAuthenticated: true,
      };
    case actionTypes.RESEND_REGISTER_AUTHENTICATED_FULFILLED:
      return {
        ...globalState,
        isLoadingReSendRegisterAuthenticated: false,
        reSendRegisterAuthenticatedMessage: action.data,
      };
    case actionTypes.RESEND_REGISTER_AUTHENTICATED_FAILURE:
      return {
        ...globalState,
        isLoadingReSendRegisterAuthenticated: false,
        reSendRegisterAuthenticatedFailed: action.error,
      };
    // 註冊
    case actionTypes.POST_REGISTER_PENDING:
      return {
        ...globalState,
        isLoadingRegister: true,
      };
    case actionTypes.POST_REGISTER_FULFILLED:
      return {
        ...globalState,
        isLoadingRegister: false,
        registerMessage: action.data,
        registerFailed: '',
      };
    case actionTypes.POST_REGISTER_FAILURE:
      return {
        ...globalState,
        isLoadingRegister: false,
        registerMessage: '',
        registerFailed: action.error,
      };

    // 註冊時檢查重複帳號
    case actionTypes.CHECK_REPEAT_ACCOUNT_PENDING:
      return {
        ...globalState,
        isLoadingCheckRepeatAccount: true,
      };
    case actionTypes.CHECK_REPEAT_ACCOUNT_FULFILLED:
      return {
        ...globalState,
        isLoadingCheckRepeatAccount: false,
        checkRepeatAccountMessage: action.data,
      };
    case actionTypes.CHECK_REPEAT_ACCOUNT_FAILURE:
      return {
        ...globalState,
        isLoadingCheckRepeatAccount: false,
        checkRepeatAccountFailed: action.error,
      };
    // 忘記密碼發送密碼重設信
    case actionTypes.SEND_FORGOT_PASSWORD_EMAIL_PENDING:
      return {
        ...globalState,
        isLoadingSendForgotPasswordEmail: true,
      };
    case actionTypes.SEND_FORGOT_PASSWORD_EMAIL_FULFILLED:
      return {
        ...globalState,
        isLoadingSendForgotPasswordEmail: false,
        sendForgotPasswordEmailMessage: action.data,
        sendForgotPasswordEmailFailed: '',
      };
    case actionTypes.SEND_FORGOT_PASSWORD_EMAIL_FAILURE:
      return {
        ...globalState,
        isLoadingSendForgotPasswordEmail: false,
        sendForgotPasswordEmailMessage: '',
        sendForgotPasswordEmailFailed: action.error,
      };
    // 重設密碼
    case actionTypes.RESET_NEW_PASSWORD_PENDING:
      return {
        ...globalState,
        isLoadingResetNewPassword: true,
      };
    case actionTypes.RESET_NEW_PASSWORD_FULFILLED:
      return {
        ...globalState,
        isLoadingResetNewPassword: false,
        resetNewPasswordMessage: action.data,
      };
    case actionTypes.RESET_NEW_PASSWORD_FAILURE:
      return {
        ...globalState,
        isLoadingResetNewPassword: false,
        resetNewPasswordFailed: action.error,
      };
    // 檢查 token 是否過期
    case actionTypes.CHECK_TOKEN_EXPIRED_PENDING:
      return {
        ...globalState,
        isLoadingCheckTokenExpired: true,
      };
    case actionTypes.CHECK_TOKEN_EXPIRED_FULFILLED:
      return {
        ...globalState,
        isLoadingCheckTokenExpired: false,
        checkTokenExpiredMessage: action.data,
        checkTokenExpiredFailed: '',
      };
    case actionTypes.CHECK_TOKEN_EXPIRED_FAILURE:
      return {
        ...globalState,
        isLoadingCheckTokenExpired: false,
        checkTokenExpiredMessage: '',
        checkTokenExpiredFailed: action.error,
      };
    default:
      return globalState;
  }
}
export { authReducer as default };
